






























import Vue from "vue";
import * as R from "@/router/routes";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetDashboardSharingTokenResData } from "@/model/communication/dashboard/dashboard/GetDashboardSharingTokenResData";
import { GetDashboardSharingTokenCommand } from "@/model/communication/dashboard/dashboard/GetDashboardSharingTokenCommand";
import { RemoveDashboardSharingTokenCommand } from "@/model/communication/dashboard/dashboard/RemoveDashboardSharingTokenCommand";

export default Vue.extend({
    data() {
        return {
            copiedToClipboard: false,
            canCopy: window.isSecureContext,
            sharingToken: null,
        };
    },
    computed: {
        publicURL() {
            let base = window.location.origin + window.location.pathname + "#" + R.SingleDashboardId(this.dashboardID) + "?st=";
            if (this.sharingToken) return base + this.sharingToken;
            if (this.existingSharingToken) return base + this.existingSharingToken;
            else return null;
        },
    },
    props: {
        dashboardID: { required: true },
        existingSharingToken: { required: true },
    },
    methods: {
        async copyToClipboard() {
            await navigator.clipboard.writeText(this.publicURL);
            console.log("Async: Copying to clipboard was successful!");

            this.copiedToClipboard = true;
            setTimeout(() => {
                this.copiedToClipboard = false;
            }, 2000);
        },

        async getSharingToken() {
            try {
                let res: GetDashboardSharingTokenResData = await new GetDashboardSharingTokenCommand(this.dashboardID).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                    this.sharingToken = res.sharingToken;
                    this.$emit("reload");
                }
            } catch (error) {
                console.error("Exception executing GetDashboardSharingTokenCommand, error:", error);
            }
        },

        async removeSharingToken() {
            try {
                let res = await new RemoveDashboardSharingTokenCommand(this.dashboardID).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                    this.sharingToken = null;
                    this.$emit("close");
                }
            } catch (error) {
                console.error("Exception executing GetDashboardSharingTokenCommand, error:", error);
            }
        },
    },
});
